<template lang="pug">
#app.app(:data-route="$route.name")
  //- navv(:visible="navVisible", type='bottom')
  transition(
    :name="transition", 
    v-on:enter="entering = true", 
    v-on:after-leave="entering = false")
    keep-alive
      router-view(
        :currentData="current", 
        :projects="projects", 
        :info="info", 
        :entering="entering", 
        :savedPosition="savedPosition")
  vue-progress-bar
</template>

<script>
import Vue from 'vue'
import Prismic from 'prismic-javascript'
import Navv from '@/components/Nav'

export default {
  name: 'app',
  components: {
    Navv
  },
  data () {
    return {
      transition: 'page',
      savedPosition: 0,
      info: null,
      projects: null,
      current: null,
      // news: null,
      entering: false
    }
  },
  computed: {
    navVisible () {
      // return this.$route.name.indexOf('Project') === -1 || this.$route.name.indexOf('Current') === -1
      return this.$route.name === 'Info'
    }
  },
  watch: {
    '$route' (to, from) {
      // console.log(this.$route.name);
      // save Projects scroll position
      const prjs = this.$el.querySelector('.projects .main')
      if (prjs) this.savedPosition = prjs.scrollTop
      // transitions
      if (from.name.indexOf('Project') === 0) this.transition = 'slidedown'
      else if (from.name.indexOf('Current') === 0) this.transition = 'slidedown'
      else if (to.name.indexOf('Project') === 0) this.transition = 'slideup'
      else if (to.name.indexOf('Current') === 0) this.transition = 'slideup'
      else this.transition = 'page'
      // console.log('this.transition', this.transition)
    }
  },
  mounted () {
    const setVh = () => {
      // console.log('setVh');
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    window.addEventListener('load', setVh);
    window.addEventListener('resize', setVh);
  },
  methods: {
    getProjects () {
      this.$Progress.start()
      // Get the Order
      Prismic.getApi(Vue.config.PRISMIC.API).then(function (api) {
        return api.query(
          Prismic.Predicates.at('document.type', 'projects-index')
        )
      }).then((response) => {
        const prjs = response.results[0].data.projects
        const projectIDs = []
        for (var i = 0; i < prjs.length; i++) {
          projectIDs.push(prjs[i].project.id)
        }
        // Get the Projects
        Prismic.getApi(Vue.config.PRISMIC.API).then(function (api) {
          return api.query(
            Prismic.Predicates.in('document.id', projectIDs),
            {pageSize: 100}
          )
        }).then((response) => {
          this.$Progress.finish()
          this.projects = response.results
        }, (err) => {
          this.$Progress.fail()
          console.log('Error: Get Projects failed', err)
        })
      }, (err) => {
        this.$Progress.fail()
        console.log('Error: Get Project Index failed', err)
      })
    },
    getInfo () {
      Prismic.getApi(Vue.config.PRISMIC.API).then(function (api) {
        return api.getSingle('info')
      }).then((response) => {
        this.info = response
      }, function (err) {
        console.log('Error: Get Info failed', err)
      })
    },
    getCurrent () {
      Prismic.getApi(Vue.config.PRISMIC.API).then(function (api) {
        return api.getSingle('current')
      }).then((response) => {
        this.current = response
        // this.projects.current = response
      }, function (err) {
        console.log('Error: Get Current failed', err)
      })
    }
    // getNews () {
    //   Prismic.getApi(Vue.config.PRISMIC.API).then((api) => {
    //     return api.query(
    //       Prismic.Predicates.at('document.type', 'news'),
    //       {pageSize: 6, page: 1, orderings: '[document.date desc]'}
    //     )
    //   }).then((response) => {
    //     this.news = response.results
    //   }, (err) => {
    //     this.$Progress.fail()
    //     console.log('Error: getNews', err)
    //   })
    // }
  },
  created () {
    this.getCurrent()
    this.getProjects()
    this.getInfo()
    // this.getNews()
  }
}
</script>

<style lang="scss">
@import './style/variables';
@import './style/base';
@import './style/transitions';

.app{
  position: relative;
  width:100%;
  /* min-height:100vh; */
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  overflow-x:hidden;
  text-align:center;
  background:$color-wht;
  
  overflow-y: hidden;

  .bar{
    background:$color-wht;
    position: fixed;
    left:0; top:0;
    width:100%;
    z-index:$z-nav;
    min-height:$nav-h;
    padding:.25em $pad;
    display:flex;
    align-items:center;
    justify-content:center;

    .serif{
      display: inline-block;
      padding-top:1px;
    }
  }

}
xmp {
  background: black;
  color: #fafafa;
  padding: 10px;
  font-size: 10px;
  line-height: 12px;
  margin: 1rem 0;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// App.vue?63369d30